import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/tomorrow/400.css';
import '@fontsource/tomorrow/500.css';
import '@fontsource/tomorrow/600.css';
import '@fontsource/tomorrow/700.css';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
